module.exports = __webpack_public_path__ + "img/alang-pro.874c9e6e.jpg";